import React, { useEffect, useRef, useState, forwardRef } from "react";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import { Body2, Heading3, Heading6 } from "app/popleads/components/ui-kit/Text";
import InputWithIcon from "app/popleads/components/ui-kit/Input";
import { useExtensionContext } from "app/popleads/modules/extension/ExtensionContext";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "_metronic/_helpers";
import CustomSelect from "app/popleads/components/ui-kit/Select";
import { post } from "app/popleads/networking/RequestService";
import useChangeProfileContactedStatus from "app/popleads/hooks/useChangeProfileContactedStatus";
import { toast } from "react-toastify";
import * as yup from "yup";
import FeatherIcon from "feather-icons-react";
import useDeleteProfileInfo from "app/popleads/hooks/useDeleteProfileInfo";
import Modal from "app/popleads/components/ui-kit/Modal";
import { apiErrorText } from "app/popleads/networking/apiErrorText";
import { AiEmailText, AiSpark } from "app/popleads/modules/extension/components/AiEmailSuggestion";
import useEmailSuggestions from "app/popleads/hooks/useEmailSuggestions";
import useSaveSuggestedEmail, {
    patternLikelihood,
    shownSuggestions,
} from "app/popleads/modules/extension/useSaveSuggestedEmail";

export const fallbackSrc = "/media/users/default.jpg";

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ImageSection = styled.div`
    min-height: ${(props) => props.size || "70px"};
    min-width: ${(props) => props.size || "70px"};
    max-height: ${(props) => props.size || "70px"};
    max-width: ${(props) => props.size || "70px"};
    border-radius: 50%;
    padding: 1px;
    opacity: 1;
    background: transparent
        linear-gradient(
            90deg,
            ${colors.success[500]} 0%,
            #f6f8f914 37%,
            #f6f8f900 50%,
            #f6f8f914 63%,
            ${colors.success[500]} 100%
        )
        0% 0% no-repeat padding-box;
    text-align: center;
`;

export const ImageBorder = styled.div`
    background-color: ${colors.neutral[50]};
    border-radius: 50%;
    padding: 4px;
    width: 100%;
    height: 100%;
`;
const StyledPlaceHolder = styled.span`
    color: ${colors.neutral[500]};
`;
export const Image = styled.img`
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    padding: 4px;
    border-radius: 50%;
    border: 1px solid ${colors.success[900]};
`;

const Star = styled.div`
    display: inline-block;
    height: 24px;
    width: 24px;
    background-color: #00856b;
    border-radius: 50%;
    color: #ffffff;
    position: relative;
    top: -23px;
    font-size: 18px;
    text-align: center;
    line-height: 24px;
`;

const ProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 0 0 12px;
    color: ${({ inActive }) => (inActive ? colors.neutral[500] : colors.neutral[800])};
    //justify-content: center;
    flex: 1;
    // margin-top: 6px;
    width: calc(81px - 100%);
    // overflow: hidden;
    gap: 2px;
    justify-content: center;
`;

const Name = styled(Heading3)`
    line-height: 1.3;
    color: ${colors.neutral[900]};
    overflow: hidden;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
    // overflow: hidden;
    // text-overflow: ellipsis;
    font-size: 16px;
    //font-size:${(props) => (props.isMultiline ? "14px" : "16px")};
    // max-height: 3rem;
    // width: 100%;
    // word-break: break-word;

    // span {
    //     display: -webkit-box;
    //     -webkit-line-clamp: 2;
    //     -webkit-box-orient: vertical;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     width: 100%;
    // }
`;

const Title = styled(Heading6)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    cursor: default;
    gap: 2px;
    font-size: 14px;
    line-height: 14px;
`;

const ProfileMenu = styled.div`
    padding: 0;
    display: flex;
    align-items: center;
`;

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;

    & > span {
        display: -webkit-box !important;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-word;
        // display: inline-block !important;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
    }

    &:hover {
        color: inherit;
    }
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;

    &.title {
        overflow: hidden;
        max-width: 100%;
    }
`;

const EditableWrapper = styled.span`
    display: flex;
    align-items: center;
    min-width: 0;
    width: 100%;

    &.title {
        max-width: 100%;
        width: 100%;

        > span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            width: 100%;
        }
    }
`;
const MailIconWrapper = styled.span`
    display: flex;
    width: 0;
    min-width: 0;
    overflow: hidden;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s;
    margin-left: 4px;
    height: 17px;
    gap: 5px;
`;
const StyledMailContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 4px;
    align-items: center;
    position: relative;
    &:hover ${MailIconWrapper} {
        min-width: fit-content;
        opacity: 1;
    }
    &:focus-within ${MailIconWrapper} {
        min-width: 0;
        opacity: 0;
    }
`;
const InfoText = styled(Body2)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    //flex: 0 0 91%;
    //max-width: 91%;
    flex: auto;
    font-size: 14px;
`;
const InfoEmailText = styled(InfoText)`
    //flex: 0 0 91%;
    //max-width: 91%;
    flex: auto;
    font-size: 14px;
`;
const MoreButton = styled.button`
    width: 19px;
    height: 19px;
    padding: 0;
    margin: 0;
    border: none;
    color: ${colors.neutral[700]};
    background-color: transparent;
`;

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
    height: 16px !important;
    min-width: 14px !important;
    background: none !important;
    border: none !important;
    padding: 0 !important;
    color: inherit !important;
    box-shadow: none !important;
    line-height: 0 !important;

    &:hover,
    &:active,
    &:focus {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        color: inherit !important;
    }

    &:after {
        display: none !important;
    }
`;

const StyledProfileDropdownItem = styled(Dropdown.Item)`
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    svg {
        height: 14px !important;
        width: 14px !important;
    }
`;

const StyledDropdownMenu = styled(Dropdown.Menu)`
    padding: 8px;
    min-width: 180px;
    max-width: max-content;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid ${colors.neutral[200]};
    top: -1px !important;

    .dropdown-item {
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 14px;

        &:hover {
            background-color: ${colors.neutral[100]};
        }

        &:active {
            background-color: ${colors.primary[100]};
            color: ${colors.primary[700]};
        }
    }

    .dropdown-divider {
        margin: 4px 0;
        border-color: ${colors.neutral[200]};
    }
`;

export const StyledTooltip = styled(Tooltip)`
    .tooltip-inner {
        font-size: 11px !important;
    }
`;

const SVGWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 17px;
    margin-right: 4px;
`;
const StyledMailIcon = styled(FeatherIcon)`
    color: ${colors.neutral[950]} !important;
    width: 14px;
`;

const StyledSpan = styled.span`
    ${(props) =>
        props.textTruncate &&
        `display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;`}
`;
const StyledNotAvailableContainer = styled.div``;

const StyledLink = styled.a`
    line-height: 0;
    color: inherit;
    text-decoration: none;
    &:hover {
        color: inherit;
    }
`;

const emailValidationSchema = yup
    .string()
    .email("Invalid email format")
    .max(140, "Email must be at most 140 characters");

const phoneValidationSchema = yup.string().max(140, "Phone number must be at most 140 characters");

const ProfileCard = forwardRef(({ variant, ...props }, ref) => {
    const { profile, setProfile, setState, urlParams, handleUpdateProfile, leadEmails } = useExtensionContext();

    // Field adlarını kullanıcıya uygun göstermek için mapping
    const FIELD_LABELS = {
        email: "email",
        email2: "email",
        tel: "phone",
        tel2: "phone",
        tel3: "phone",
    };

    const [isMultiline, setIsMultiline] = useState(false);
    const nameRef = useRef(null);
    const [show, setShow] = useState(false);
    const { deleteProfileInfo } = useDeleteProfileInfo();

    // Copy to clipboard function with toast notification
    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            toast.success("Copied to clipboard");
        } catch (error) {
            toast.error("Failed to copy to clipboard");
        }
    };

    const { changeContactedStatus } = useChangeProfileContactedStatus();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [fieldToDelete, setFieldToDelete] = useState(null);
    const [valueToDelete, setValueToDelete] = useState(null);
    const [addNewField, setAddNewField] = useState(null);
    // AI-suggested emails from the account's pattern; an address the profile already has is not repeated
    const {
        suggestions: emailSuggestions,
        emailPattern: suggestionPattern,
        verifying: verifyingEmails,
    } = useEmailSuggestions(profile?.id, [profile?.email, profile?.email2]);
    const aiEmails = shownSuggestions(emailSuggestions, profile);
    // Pop-It mode: suggestions for the LinkedIn profile before it is saved (shown only; verified once it is a profile)
    const leadAiEmails =
        !profile && leadEmails ? shownSuggestions(leadEmails.suggestions, { email: urlParams?.profil_email }) : [];
    const hasOwnEmail = Boolean(profile?.email || profile?.email2);
    const saveSuggestedEmail = useSaveSuggestedEmail();
    const [newEmailValue, setNewEmailValue] = useState("");
    const [newPhoneValue, setNewPhoneValue] = useState("");

    const handleUpdateContactDetails = async (field, value) => {
        try {
            if (field.startsWith("email")) {
                await emailValidationSchema.validate(value);
            } else {
                await phoneValidationSchema.validate(value);
            }
            handleUpdateProfile({
                field: field,
                fieldValue: value,
            });
            setAddNewField(null);
            setNewEmailValue("");
        } catch (err) {
            toast.error(err.message);
        }
    };

    const handleContactedStatus = async (status) => {
        setShow(false);
        if (profile?.contactStatus === status) return;
        setState((prevState) => ({
            ...prevState,
            loading: true,
        }));
        try {
            const response = await changeContactedStatus({ profileId: profile?.id, status });
            if (response.error) {
                toast.error(response.error);
            } else {
                toast.success("Contacted status changed successfully");
                setProfile((prevProfile) => ({ ...prevProfile, contactStatus: status }));
            }
        } finally {
            setState((prevState) => ({
                ...prevState,
                loading: false,
            }));
        }
    };

    const handleRemoveField = (field, value) => {
        setFieldToDelete(field);
        setValueToDelete(value);
        setShowDeleteModal(true);
    };

    const confirmRemoveField = async () => {
        if (!profile?.id || !valueToDelete) return;
        try {
            await deleteProfileInfo({
                fn: "deleteProfileInfo",
                profileId: profile?.id,
                param: fieldToDelete,
                paramValue: valueToDelete,
            });
            setProfile((prev) => ({ ...prev, [fieldToDelete]: "" }));
            toast.success("Deleted successfully");
        } catch (e) {
            toast.error(apiErrorText(e));
        } finally {
            setShowDeleteModal(false);
            setFieldToDelete(null);
            setValueToDelete(null);
        }
    };

    const checkMultiline = () => {
        if (nameRef.current) {
            const nameSpan = nameRef.current.querySelector("span");
            if (nameSpan) {
                const spanHeight = nameSpan.offsetHeight;
                const lineHeight = parseInt(getComputedStyle(nameSpan).lineHeight);
                setIsMultiline(spanHeight > lineHeight);
            }
        }
    };

    useEffect(() => {
        checkMultiline();
        window.addEventListener("resize", checkMultiline);
        return () => window.removeEventListener("resize", checkMultiline);
    }, [profile?.ad, profile?.soyad]);

    const getLinkedinUsername = (site) => {
        if (!site) return "";
        const newUrl = site[site.length - 1] === "/" ? site.slice(0, -1) : site;
        return newUrl.replace("https://www.linkedin.com/in/", "");
    };

    const FIELD_NAMES = {
        ad: "Name",
        site: "Linkedin URL",
        resim: "Image",
        baslik: "Title",
        sirket: "Company",
        country: "City/Country",
    };

    const compareLinkedinUrls = (url1, url2) => {
        const username1 = getLinkedinUsername(url1);
        const username2 = getLinkedinUsername(url2);
        return username1 === username2;
    };

    const fullName = profile?.ad && profile?.soyad ? `${profile?.ad} ${profile?.soyad}` : profile?.ad || profile?.soyad;
    const cityAndCountry = profile?.city ? `${profile?.city}, ${profile?.country}` : profile?.country;

    const existingEmails = [profile?.email, profile?.email2]
        .filter((val) => val && typeof val === "string" && val.trim() !== "")
        .map((val) => val.trim());

    const existingPhones = [profile?.tel, profile?.tel2, profile?.tel3]
        .filter((val) => val && typeof val === "string" && val.trim() !== "")
        .map((val) => val.trim());

    const hasChanges =
        (urlParams?.profil_ad !== undefined &&
            urlParams?.profil_ad !== null &&
            urlParams?.profil_ad?.toLowerCase() !== fullName?.normalize()?.toLowerCase()) ||
        (urlParams?.profil_baslik !== undefined &&
            urlParams?.profil_baslik !== null &&
            urlParams?.profil_baslik !== profile?.baslik) ||
        (urlParams?.profil_sirket !== undefined &&
            urlParams?.profil_sirket !== null &&
            urlParams?.profil_sirket !== profile?.sirket) ||
        (urlParams?.profil_ulke !== undefined &&
            urlParams?.profil_ulke !== null &&
            urlParams?.profil_ulke !== cityAndCountry) ||
        (urlParams?.profil_tel !== undefined &&
            urlParams?.profil_tel !== null &&
            urlParams?.profil_tel &&
            !existingPhones.includes(urlParams.profil_tel.trim())) ||
        (urlParams?.profil_email !== undefined &&
            urlParams?.profil_email !== null &&
            urlParams?.profil_email &&
            !existingEmails.includes(urlParams.profil_email.trim()));

    const renderWarningIcon = (field, value, tooltip) => {
        if (value === undefined || value === null) return null;
        return (
            <OverlayTrigger placement="top" overlay={<StyledTooltip>{tooltip}</StyledTooltip>}>
                <div
                    style={{ cursor: "pointer", display: "inline-flex" }}
                    onClick={() =>
                        setState({
                            popupContent: "About",
                            popupIsOpen: true,
                            selectedModal: "updateProfile",
                            fieldToUpdate: { field, value },
                        })
                    }
                >
                    <SVG src={toAbsoluteUrl("/media/svg/popleads/warning2.svg")} />
                </div>
            </OverlayTrigger>
        );
    };

    return (
        <>
            <Container {...props} ref={ref}>
                <div style={{ display: "flex" }}>
                    <ImageSection>
                        <ImageBorder style={{ position: "relative" }}>
                            <Image
                                src={
                                    urlParams?.profil_resim && !urlParams?.profil_resim.startsWith("data:image")
                                        ? urlParams?.profil_resim
                                        : profile?.resim || fallbackSrc
                                }
                                alt="profile"
                                onError={(e) => (e.currentTarget.src = fallbackSrc)}
                            />
                        </ImageBorder>
                        {profile?.dealsWonCount > 0 && (
                            <OverlayTrigger
                                key="bottom"
                                placement="bottom"
                                overlay={
                                    <StyledTooltip id={`tooltip-bottom`}>
                                        <strong>{`Has ${profile?.dealsWonCount} Won ${
                                            profile?.dealsWonCount < 2 ? "Deal" : "Deals"
                                        }`}</strong>
                                    </StyledTooltip>
                                }
                            >
                                {<Star className="material-symbols-outlined">star</Star>}
                            </OverlayTrigger>
                        )}
                    </ImageSection>
                    <ProfileInfo inActive={variant === "neutralInActive"}>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <Name ref={nameRef} isMultiline={isMultiline}>
                                <NameWrapper as={"a"} href="#" onClick={(e) => e.preventDefault()}>
                                    <EditableWrapper>
                                        {profile ? (
                                            <EditableField
                                                value={fullName}
                                                placeholder={!fullName && "No name available"}
                                                field="ad"
                                                tooltip={`Full Name: ${fullName || ""}`}
                                                validationSchema={yup
                                                    .string()
                                                    .required("Full name is required")
                                                    .test(
                                                        "two-words",
                                                        "Full name must contain at least two words",
                                                        (value) => value && value.trim().split(/\s+/).length >= 2
                                                    )
                                                    .max(140, "Full name must be at most 140 characters")}
                                            />
                                        ) : urlParams?.profil_ad ? (
                                            urlParams?.profil_ad
                                        ) : (
                                            "Not available"
                                        )}
                                    </EditableWrapper>
                                    {variant === "neutralInActive" &&
                                        urlParams?.profil_ad?.toLowerCase() !== fullName?.normalize()?.toLowerCase() &&
                                        renderWarningIcon(
                                            "ad",
                                            urlParams?.profil_ad,
                                            `Changed to ${urlParams?.profil_ad}, click to apply changes`
                                        )}
                                </NameWrapper>
                            </Name>

                            {variant !== "neutralInActive" && profile ? (
                                <div>
                                    <ProfileMenu>
                                        {hasChanges && (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<StyledTooltip>Profile has changes to apply</StyledTooltip>}
                                            >
                                                <div
                                                    style={{
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "19px",
                                                    }}
                                                    onClick={() => setState({ popupContent: "About" })}
                                                >
                                                    <SVG src={toAbsoluteUrl("/media/svg/popleads/warning2.svg")} />
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<StyledTooltip className="text-capitalize">About</StyledTooltip>}
                                        >
                                            <MoreButton
                                                onClick={() => {
                                                    setState({
                                                        popupContent: "About",
                                                        popupIsOpen: true,
                                                        selectedModal: null,
                                                        itemToDelete: null,
                                                    });
                                                }}
                                            >
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{ fontSize: "19px" }}
                                                >
                                                    more_vert
                                                </span>
                                            </MoreButton>
                                        </OverlayTrigger>
                                    </ProfileMenu>
                                </div>
                            ) : null}
                        </div>
                        {variant === "neutralInActive" ? (
                            <>
                                <Title
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    {profile ? (
                                        <EditableField
                                            placeholder={!profile?.site && "Edit LinkedIn URL"}
                                            value={getLinkedinUsername(profile?.site)}
                                            field="site"
                                            prefix="/in/"
                                            showFullUrlInEdit={true}
                                            tooltip={`LinkedIn URL: /in/${getLinkedinUsername(profile?.site)}`}
                                        />
                                    ) : (
                                        getLinkedinUsername(urlParams?.profil_url)
                                    )}

                                    {/* <span>{profile?.site ? getLinkedinUsername(profile?.site) : "-"}</span> */}
                                    {!compareLinkedinUrls(urlParams?.profil_url, profile?.site) &&
                                        renderWarningIcon(
                                            "site",
                                            urlParams?.profil_url,
                                            `Changed to ${FIELD_NAMES.site}`
                                        )}
                                </Title>
                                <Title>Passcode: {profile?.id}</Title>
                            </>
                        ) : (
                            <>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                    <Title style={{ width: "calc(100% - 17px)" }}>
                                        {
                                            <TitleWrapper>
                                                {profile ? (
                                                    <EditableWrapper>
                                                        <EditableField
                                                            value={profile?.sirket}
                                                            field="sirket"
                                                            inputType="select"
                                                            tooltip={`Account Name: ${profile?.sirket}`}
                                                            textTruncate={true}
                                                        />
                                                    </EditableWrapper>
                                                ) : (
                                                    <div
                                                        style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {urlParams?.profil_sirket
                                                            ? urlParams?.profil_sirket
                                                            : "Not available"}
                                                    </div>
                                                )}
                                            </TitleWrapper>
                                        }
                                        {
                                            <TitleWrapper>
                                                {profile ? (
                                                    <InfoEmailText>
                                                        <EditableField
                                                            value={profile?.baslik}
                                                            field="baslik"
                                                            tooltip={`Title: ${profile?.baslik}`}
                                                            validationSchema={yup
                                                                .string()
                                                                .max(150, "Title must be at most 150 characters")}
                                                        />
                                                    </InfoEmailText>
                                                ) : (
                                                    <div
                                                        style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {urlParams?.profil_baslik
                                                            ? urlParams?.profil_baslik
                                                            : "Not available"}
                                                    </div>
                                                )}
                                            </TitleWrapper>
                                        }
                                    </Title>

                                    <div
                                        style={{
                                            gap: "2px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Dropdown
                                            onMouseEnter={() => setShow(true)}
                                            onMouseLeave={() => setShow(false)}
                                            show={show}
                                            style={{ lineHeight: "0" }}
                                        >
                                            <StyledDropdownToggle id="profile-actions-dropdown">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <StyledTooltip className="text-capitalize">
                                                            {profile?.contactStatus}
                                                        </StyledTooltip>
                                                    }
                                                >
                                                    <span>
                                                        {profile?.contactStatus === "Contacted" ? (
                                                            <SVG
                                                                style={{
                                                                    width: "14px",
                                                                    height: "14px",
                                                                }}
                                                                src={toAbsoluteUrl(
                                                                    "/media/svg/popleads/phone-success.svg"
                                                                )}
                                                            />
                                                        ) : profile?.contactStatus === "Not Reached" ? (
                                                            <SVG
                                                                style={{
                                                                    fill: "#F0A1A1",
                                                                    stroke: "#F0A1A1",
                                                                    width: "14px",
                                                                    height: "14px",
                                                                }}
                                                                src={toAbsoluteUrl(
                                                                    "/media/svg/popleads/phone-missed.svg"
                                                                )}
                                                            />
                                                        ) : profile?.contactStatus === "Not Contacted" ? (
                                                            <SVG
                                                                style={{
                                                                    width: "14px",
                                                                    height: "14px",
                                                                }}
                                                                src={toAbsoluteUrl("/media/svg/popleads/phone-off.svg")}
                                                            />
                                                        ) : null}
                                                    </span>
                                                </OverlayTrigger>
                                            </StyledDropdownToggle>
                                            <StyledDropdownMenu>
                                                <StyledProfileDropdownItem
                                                    onClick={() => {
                                                        handleContactedStatus("Contacted");
                                                    }}
                                                >
                                                    <SVG src={toAbsoluteUrl("/media/svg/popleads/phone-success.svg")} />
                                                    Contacted
                                                </StyledProfileDropdownItem>
                                                <StyledProfileDropdownItem
                                                    onClick={() => {
                                                        handleContactedStatus("Not Reached");
                                                    }}
                                                >
                                                    <SVG
                                                        style={{
                                                            fill: "#F0A1A1",
                                                            stroke: "#F0A1A1",
                                                            width: "14px",
                                                        }}
                                                        src={toAbsoluteUrl("/media/svg/popleads/phone-missed.svg")}
                                                    />
                                                    Not Reached
                                                </StyledProfileDropdownItem>
                                                <StyledProfileDropdownItem
                                                    onClick={() => {
                                                        handleContactedStatus("Not Contacted");
                                                    }}
                                                >
                                                    <SVG src={toAbsoluteUrl("/media/svg/popleads/phone-off.svg")} />
                                                    Not Contacted
                                                </StyledProfileDropdownItem>
                                            </StyledDropdownMenu>
                                        </Dropdown>
                                        {profile?.site && (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<StyledTooltip>Open LinkedIn Profile</StyledTooltip>}
                                            >
                                                <StyledLink
                                                    href={profile?.site}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ lineHeight: "0" }}
                                                >
                                                    <FeatherIcon icon="linkedin" size={14} />
                                                </StyledLink>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </ProfileInfo>
                </div>
                {variant !== "neutralInActive" && (
                    <div style={{ marginTop: "12px", display: "flex", flexDirection: "column", gap: "6px" }}>
                        {profile ? (
                            <>
                                {(profile?.email || (!hasOwnEmail && !aiEmails.length)) && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="mail" size="14" />
                                        </SVGWrapper>
                                        <InfoEmailText>
                                            <EditableField
                                                placeholder={!profile?.email && "Add Email"}
                                                value={profile?.email}
                                                field="email"
                                                tooltip={`Email: ${profile?.email}`}
                                                validationSchema={emailValidationSchema}
                                            />
                                        </InfoEmailText>
                                        <MailIconWrapper className="mail-icon-on-hover">
                                            {profile?.email && !profile?.email2 && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>Add Another Email</Tooltip>}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            color: colors.l3rnTech[900],
                                                        }}
                                                        onClick={() => setAddNewField("email2")}
                                                    >
                                                        <FeatherIcon icon="plus" size={17} />
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                            {profile?.email && (
                                                <>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>Copy Email</Tooltip>}
                                                    >
                                                        <span
                                                            style={{
                                                                cursor: "pointer",
                                                                color: colors.l3rnTech[900],
                                                            }}
                                                            onClick={() => copyToClipboard(profile?.email)}
                                                        >
                                                            <FeatherIcon icon="copy" size={17} />
                                                        </span>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>Send Mail</Tooltip>}
                                                    >
                                                        <span
                                                            onClick={() =>
                                                                (window.location.href = `mailto:${profile?.email}`)
                                                            }
                                                            style={{ lineHeight: "0", cursor: "pointer" }}
                                                        >
                                                            <FeatherIcon color icon="send" size={17} />
                                                        </span>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>Remove Email</Tooltip>}
                                                    >
                                                        <span
                                                            style={{
                                                                cursor: "pointer",
                                                                marginLeft: "4px",
                                                                color: colors.danger[900],
                                                            }}
                                                            onClick={() => handleRemoveField("email", profile?.email)}
                                                        >
                                                            <FeatherIcon icon="x" size={17} />
                                                        </span>
                                                    </OverlayTrigger>
                                                </>
                                            )}
                                        </MailIconWrapper>
                                    </StyledMailContainer>
                                )}
                                {profile?.email2 && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="mail" size="14" />
                                        </SVGWrapper>
                                        <InfoEmailText>
                                            <EditableField
                                                placeholder={!profile?.email2 && "Add Email"}
                                                value={profile?.email2}
                                                field="email2"
                                                tooltip={`Second Email: ${profile?.email2}`}
                                                validationSchema={emailValidationSchema}
                                            />
                                        </InfoEmailText>
                                        <MailIconWrapper className="mail-icon-on-hover">
                                            {!profile?.email && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>Add Another Email</Tooltip>}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            color: colors.l3rnTech[900],
                                                        }}
                                                        onClick={() => setAddNewField("email")}
                                                    >
                                                        <FeatherIcon icon="plus" size={17} />
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Copy Email</Tooltip>}>
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        color: colors.l3rnTech[900],
                                                    }}
                                                    onClick={() => copyToClipboard(profile?.email2)}
                                                >
                                                    <FeatherIcon icon="copy" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Send Mail</Tooltip>}>
                                                <span
                                                    onClick={() => (window.location.href = `mailto:${profile?.email2}`)}
                                                    style={{ lineHeight: "0", cursor: "pointer" }}
                                                >
                                                    <FeatherIcon icon="send" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Remove Email</Tooltip>}>
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        marginLeft: "4px",
                                                        color: colors.danger[900],
                                                    }}
                                                    onClick={() => handleRemoveField("email2", profile?.email2)}
                                                >
                                                    <FeatherIcon icon="x" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                        </MailIconWrapper>
                                    </StyledMailContainer>
                                )}
                                {aiEmails.map((s) => (
                                    <StyledMailContainer key={`ai-${s.email}`} data-testid="email-suggestion">
                                        <SVGWrapper>
                                            <AiSpark fontSize="14px" title="AI suggestion" />
                                        </SVGWrapper>
                                        <InfoEmailText>
                                            <AiEmailText
                                                email={s.email}
                                                muted={s.ownedByOtherProfile}
                                                verification={s.verification}
                                                verifying={verifyingEmails}
                                                likelihood={patternLikelihood(suggestionPattern, s.pattern)}
                                                onSave={saveSuggestedEmail}
                                            />
                                        </InfoEmailText>
                                    </StyledMailContainer>
                                ))}
                                {["email", "email2"].includes(addNewField) && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="mail" size="14" />
                                        </SVGWrapper>
                                        <InfoEmailText>
                                            <InputWithIcon
                                                key={`new-${addNewField}`}
                                                placeholder={"Add Email"}
                                                debounceTime={0}
                                                variant="unstyled"
                                                autoFocus
                                                value={newEmailValue}
                                                onChange={(e) => {
                                                    setNewEmailValue(e.target.value);
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleUpdateContactDetails(addNewField, newEmailValue);
                                                    }
                                                }}
                                                onBlur={() => {
                                                    setAddNewField(null);
                                                    setNewEmailValue("");
                                                }}
                                            />
                                        </InfoEmailText>
                                    </StyledMailContainer>
                                )}
                                {profile?.ecommerceMail && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <img
                                                src="/media/l3rn-tech/L3RN-Tech-38x38px.png"
                                                style={{ marginLeft: "1px", maxWidth: "12px", maxHeight: "12px" }}
                                            />
                                        </SVGWrapper>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <StyledTooltip>
                                                    E-Commerce Email: {profile?.ecommerceMail}
                                                </StyledTooltip>
                                            }
                                        >
                                            <InfoEmailText>{profile?.ecommerceMail}</InfoEmailText>
                                        </OverlayTrigger>
                                        <MailIconWrapper className="mail-icon-on-hover">
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Copy Email</Tooltip>}>
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        color: colors.l3rnTech[900],
                                                    }}
                                                    onClick={() => copyToClipboard(profile?.ecommerceMail)}
                                                >
                                                    <FeatherIcon icon="copy" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Send Mail</Tooltip>}>
                                                <span
                                                    onClick={() =>
                                                        (window.location.href = `mailto:${profile?.ecommerceMail}`)
                                                    }
                                                    style={{ lineHeight: "0", cursor: "pointer" }}
                                                >
                                                    <FeatherIcon icon="send" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                        </MailIconWrapper>
                                    </StyledMailContainer>
                                )}
                                {(profile?.tel || (!profile?.tel && !profile?.tel2 && !profile?.tel3)) && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="phone" size="14" />
                                        </SVGWrapper>
                                        <InfoText>
                                            <EditableField
                                                placeholder={!profile?.tel && "Add Phone"}
                                                value={profile?.tel}
                                                field="tel"
                                                tooltip={`Mobile Phone: ${profile?.tel}`}
                                                validationSchema={phoneValidationSchema}
                                            />
                                        </InfoText>
                                        <MailIconWrapper className="mail-icon-on-hover">
                                            {profile?.tel && !profile?.tel2 && !profile?.tel3 && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>Add Another Phone</Tooltip>}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            color: colors.l3rnTech[900],
                                                        }}
                                                        onClick={() => setAddNewField(!profile?.tel2 ? "tel2" : "tel3")}
                                                    >
                                                        <FeatherIcon icon="plus" size={17} />
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                            {profile?.tel && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>Remove Phone</Tooltip>}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            marginLeft: "4px",
                                                            color: colors.danger[900],
                                                        }}
                                                        onClick={() => handleRemoveField("tel", profile?.tel)}
                                                    >
                                                        <FeatherIcon icon="x" size={17} />
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                        </MailIconWrapper>
                                    </StyledMailContainer>
                                )}
                                {profile?.tel2 && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="phone" size="14" />
                                        </SVGWrapper>
                                        <InfoText>
                                            <EditableField
                                                placeholder={!profile?.tel2 && "Add Phone"}
                                                value={profile?.tel2}
                                                field="tel2"
                                                tooltip={`Second Phone: ${profile?.tel2}`}
                                                validationSchema={phoneValidationSchema}
                                            />
                                        </InfoText>
                                        <MailIconWrapper className="mail-icon-on-hover">
                                            {!profile?.tel3 && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>Add Another Phone</Tooltip>}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            color: colors.l3rnTech[900],
                                                        }}
                                                        onClick={() => setAddNewField(!profile?.tel ? "tel" : "tel3")}
                                                    >
                                                        <FeatherIcon icon="plus" size={17} />
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Remove Phone</Tooltip>}>
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        marginLeft: "4px",
                                                        color: colors.danger[900],
                                                    }}
                                                    onClick={() => handleRemoveField("tel2", profile?.tel2)}
                                                >
                                                    <FeatherIcon icon="x" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                        </MailIconWrapper>
                                    </StyledMailContainer>
                                )}
                                {profile?.tel3 && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="phone" size="14" />
                                        </SVGWrapper>
                                        <InfoText>
                                            <EditableField
                                                placeholder={!profile?.tel3 && "Add Phone"}
                                                value={profile?.tel3}
                                                field="tel3"
                                                tooltip={`Other Phone: ${profile?.tel3}`}
                                                validationSchema={phoneValidationSchema}
                                            />
                                        </InfoText>
                                        <MailIconWrapper className="mail-icon-on-hover">
                                            {!profile?.tel || !profile?.tel2 ? (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>Add Another Phone</Tooltip>}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            color: colors.l3rnTech[900],
                                                        }}
                                                        onClick={() => setAddNewField(!profile?.tel ? "tel" : "tel2")}
                                                    >
                                                        <FeatherIcon icon="plus" size={17} />
                                                    </span>
                                                </OverlayTrigger>
                                            ) : null}
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Remove Phone</Tooltip>}>
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        marginLeft: "4px",
                                                        color: colors.danger[900],
                                                    }}
                                                    onClick={() => handleRemoveField("tel3", profile?.tel3)}
                                                >
                                                    <FeatherIcon icon="x" size={17} />
                                                </span>
                                            </OverlayTrigger>
                                        </MailIconWrapper>
                                    </StyledMailContainer>
                                )}
                                {["tel", "tel2", "tel3"].includes(addNewField) && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <StyledMailIcon strokeWidth="1px" icon="phone" size="14" />
                                        </SVGWrapper>
                                        <InfoEmailText>
                                            <InputWithIcon
                                                key={`new-${addNewField}`}
                                                placeholder={"Add Phone"}
                                                debounceTime={0}
                                                variant="unstyled"
                                                autoFocus
                                                value={newPhoneValue}
                                                onChange={(e) => {
                                                    setNewPhoneValue(e.target.value);
                                                }}
                                                onKeyPress={async (e) => {
                                                    if (e.key === "Enter") {
                                                        handleUpdateContactDetails(addNewField, newPhoneValue);
                                                    }
                                                }}
                                                onBlur={() => {
                                                    setAddNewField(null);
                                                    setNewPhoneValue("");
                                                }}
                                            />
                                        </InfoEmailText>
                                    </StyledMailContainer>
                                )}
                            </>
                        ) : (
                            <StyledNotAvailableContainer>
                                {(urlParams?.profil_email || !leadAiEmails.length) && (
                                    <StyledMailContainer>
                                        <SVGWrapper>
                                            <FeatherIcon strokeWidth="1px" icon="mail" size="14" />
                                        </SVGWrapper>
                                        <InfoText>
                                            {urlParams?.profil_email ? urlParams?.profil_email : "No email available"}
                                        </InfoText>
                                    </StyledMailContainer>
                                )}
                                {leadAiEmails.map((s) => (
                                    <StyledMailContainer key={`lead-ai-${s.email}`} data-testid="lead-email-suggestion">
                                        <SVGWrapper>
                                            <AiSpark fontSize="14px" title="AI suggestion" />
                                        </SVGWrapper>
                                        <InfoEmailText>
                                            <AiEmailText
                                                email={s.email}
                                                muted={s.ownedByOtherProfile}
                                                likelihood={patternLikelihood(leadEmails.emailPattern, s.pattern)}
                                                onSave={() =>
                                                    toast.info(
                                                        "Pop-It this profile first, then click the email to save it."
                                                    )
                                                }
                                            />
                                        </InfoEmailText>
                                    </StyledMailContainer>
                                ))}
                                <StyledMailContainer>
                                    <SVGWrapper>
                                        <FeatherIcon strokeWidth="1px" icon="phone" size="14" />
                                    </SVGWrapper>
                                    <InfoText>
                                        {urlParams?.profil_tel ? urlParams?.profil_tel : "No phone available"}
                                    </InfoText>
                                </StyledMailContainer>
                            </StyledNotAvailableContainer>
                        )}
                    </div>
                )}
            </Container>
            {/* Silme onay modali */}
            <Modal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                title={`Are you sure you want to delete ${FIELD_LABELS[fieldToDelete] ||
                    fieldToDelete ||
                    "this information"}?`}
                variant="danger"
                icon="delete"
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onSuccess={confirmRemoveField}
            >
                <div>
                    {FIELD_LABELS[fieldToDelete] ? `This will remove your ${FIELD_LABELS[fieldToDelete]}.` : null}
                    This action cannot be undone.
                </div>
            </Modal>
        </>
    );
});

export default ProfileCard;

export function EditableField({
    value,
    onChange,
    field,
    setIsHidden,
    inputType,
    placeholder,
    validationSchema,
    prefix,
    tooltip = "",
    showFullUrlInEdit = false,
    textTruncate = false,
    ...props
}) {
    const [isEditing, setIsEditing] = useState(false);
    const wrapperRef = useRef(null);
    const { handleUpdateProfile, setState, modals } = useExtensionContext();
    const [inputValue, setInputValue] = useState(value);
    const [selectedOption, setSelectedOption] = useState({ value, label: value });

    const fetchQuery = async (inputValue, page) => {
        const requestObj = {
            fn: "getAccountSuggestions",
            accountName: inputValue ? inputValue : value,
            page: page,
            pageSize: 100,
        };

        try {
            const response = await post(requestObj);
            const data = response.data;
            const options = data?.accounts?.map((item) => {
                return {
                    value: item.accountName,
                    label: item.accountName,
                };
            });

            return {
                options,
                hasMore: data.totalCount ? page * 100 < data.totalCount : false,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // console.error("Error fetching data:", error);
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: 1,
                },
            };
        }
    };

    const loadOptions = (inputValue, _, { page }) =>
        new Promise((resolve) => {
            const options = fetchQuery(inputValue, page);
            resolve(options);
        });

    const handleSubmit = () => {
        const newValue = inputValue?.trim();

        if (!newValue || newValue === value) {
            setInputValue(value); // değer değişmediyse orijinal değere geri dön
            setSelectedOption({ value, label: value });
            setIsEditing(false);
            if (setIsHidden) setIsHidden("");
            return;
        }

        if (validationSchema) {
            validationSchema
                .validate(newValue)
                .then(() => {
                    handleUpdateProfile({ field: field, fieldValue: newValue }); // Parent bileşene değişikliği bildir
                    setIsEditing(false);
                    if (setIsHidden) setIsHidden("");
                })
                .catch((err) => {
                    toast.error(err.message);
                    //setInputValue(value); // hata varsa orijinal değere geri dön
                    //setSelectedOption({ value, label: value });
                    //setIsEditing(false);
                    //if (setIsHidden) setIsHidden("");
                });
        } else {
            if (field === "site") {
                setState((prevState) => ({
                    ...prevState,
                    selectedModal: modals.LINKEDIN_URL_UPDATE,
                    updateProfileParams: {
                        field: field,
                        fieldValue: newValue,
                    },
                }));
                setInputValue(value);
            } else {
                handleUpdateProfile({ field: field, fieldValue: newValue }); // Parent bileşene değişikliği bildir
            }
            setIsEditing(false);
            if (setIsHidden) setIsHidden("");
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const menuPortal = document.getElementById("newFilterMenu");
            const toastContainer = document.querySelector(".Toastify__toast-container");

            if (
                isEditing &&
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target) &&
                !menuPortal?.contains(event.target) &&
                !toastContainer?.contains(event.target)
            ) {
                setInputValue(value);
                setSelectedOption({ value, label: value });
                setIsEditing(false);
                if (setIsHidden) setIsHidden("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isEditing, inputValue, value, onChange, field, handleUpdateProfile]);

    useEffect(() => {
        setInputValue(value);
        setSelectedOption({ value, label: value });
    }, [value]);

    useEffect(() => {
        if (isEditing && inputType !== "select") {
            const input = wrapperRef.current.querySelector("input");
            input.focus();
        }
    }, [isEditing]);

    return (
        <span ref={wrapperRef} style={{ cursor: "pointer", width: "100%" }}>
            {isEditing ? (
                inputType === "select" ? (
                    <div>
                        <CustomSelect
                            variant="l3rnTech"
                            key="profile-single-select"
                            // options={options}
                            unstyled={true}
                            value={selectedOption}
                            isClearable={false}
                            isSearchable={true}
                            isCreatable={true}
                            onChange={(selection) => {
                                setSelectedOption(selection);
                                setInputValue(selection?.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSubmit();
                                } else if (e.key === "Escape") {
                                    e.preventDefault();
                                    setInputValue(value);
                                    setSelectedOption({ value, label: value });
                                    setIsEditing(false);
                                    if (setIsHidden) setIsHidden("");
                                }
                            }}
                            isMulti={false}
                            placeholder={"Creatable Async Selection..."}
                            loadOptions={loadOptions}
                            additional={{ page: 1 }}
                            menuPlacement={props.menuPlacement || "auto"}
                            onMenuOpen={props.onMenuOpen}
                        />
                    </div>
                ) : showFullUrlInEdit && field === "site" ? (
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <span style={{ color: colors.neutral[600], whiteSpace: "nowrap" }}>linkedin.com/in/</span>
                        <InputWithIcon
                            variant={"unstyled"}
                            placeholder={placeholder}
                            debounceTime={0}
                            value={inputValue || ""}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSubmit();
                                } else if (e.key === "Escape") {
                                    e.preventDefault();
                                    setInputValue(value);
                                    setIsEditing(false);
                                    if (setIsHidden) setIsHidden("");
                                }
                            }}
                            style={{ minWidth: "100px", flex: 1 }}
                        />
                    </div>
                ) : (
                    <InputWithIcon
                        variant={"unstyled"}
                        placeholder={placeholder}
                        debounceTime={0}
                        value={inputValue || ""}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleSubmit();
                            } else if (e.key === "Escape") {
                                e.preventDefault();
                                setInputValue(value);
                                setIsEditing(false);
                                if (setIsHidden) setIsHidden("");
                            }
                        }}
                    />
                )
            ) : (
                <span onClick={() => setIsEditing(true)}>
                    {value && prefix && <span>{prefix}</span>}
                    {value ? (
                        tooltip === "" ? (
                            value
                        ) : (
                            <OverlayTrigger placement="top" overlay={<StyledTooltip>{tooltip}</StyledTooltip>}>
                                <StyledSpan textTruncate={textTruncate}>{value}</StyledSpan>
                            </OverlayTrigger>
                        )
                    ) : (
                        <StyledPlaceHolder>{placeholder}</StyledPlaceHolder>
                    )}
                </span>
            )}
        </span>
    );
}
